import React from "react"
import { connect } from "react-redux"
import { Link } from "gatsby"
import { setQuantity } from "../../actions/shoppingCart"
import Img from "gatsby-image"
import S from "./CartListProduct.module.scss"
import QuantityCounter from "../Skus/QuantityCounter"
import Close from "../Icons/Close"
import RemoveFromCart from "./RemoveFromCart"

const CartProduct = props => {
  const { id, name, image, price, quantity, size, setQuantity } = props

  const RemoveProduct = RemoveFromCart(Close) // HOC takes a close icon and gives remove functionality

  // the container has been named article as there is a bug in gatsby that strips out styles if it is div
  return (
    <article key={id} className={S.product}>
      <Link className={S.name} to={`/product/${id}`}>
        <p>{name}</p>
      </Link>

      <Link className={S.image} to={`/product/${id}`}>
        <Img fluid={image} />
      </Link>

      <div className={S.details}>
        <p className={S.size}>SIZE: {size}</p>
      </div>

      <p className={S.price}>£{price}</p>

      <QuantityCounter
        id={id}
        quantity={quantity}
        customClassName={S.quantity}
        onSelectQuantity={(id, quantity) => {
          setQuantity(id, { quantity: quantity })
        }}
      />
      <p className={S.totalprice}>£{(price * quantity).toFixed(2)}</p>

      <RemoveProduct customClassName={S.removeProduct} id={id} />
    </article>
  )
}

// map state to props functions
const mapDispatchToProps = dispatch => {
  return {
    setQuantity: (id, quantity) => {
      dispatch(setQuantity(id, quantity))
    },
  }
}

export default connect(undefined, mapDispatchToProps)(CartProduct)
